import React, { useState } from 'react';
import SafeIcon from '../../common/SafeIcon';

export default function PhotoUpload({ label, helpText, onChange, t }) {
  const [preview, setPreview] = useState(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // In a real app, you would upload this to Supabase Storage or AWS S3 here
      // and get back a public URL to store in the form state.
      const objectUrl = URL.createObjectURL(file);
      setPreview(objectUrl);
      onChange(file);
    }
  };

  return (
    <div className="flex flex-col gap-1.5">
      <label className="text-sm font-medium text-gray-700">
        {label} <span className="text-emerald-600">*</span>
      </label>
      
      <div className="relative border-2 border-dashed border-gray-300 rounded-xl p-6 hover:bg-gray-50 transition-colors flex flex-col items-center justify-center cursor-pointer overflow-hidden group">
        <input
          type="file"
          accept="image/*"
          onChange={handleFileChange}
          required
          className="absolute inset-0 w-full h-full opacity-0 cursor-pointer z-10"
        />
        
        {preview ? (
          <div className="absolute inset-0 w-full h-full">
            <img src={preview} alt="ID Preview" className="w-full h-full object-cover opacity-60" />
            <div className="absolute inset-0 flex items-center justify-center bg-black/20">
              <div className="bg-white/90 px-4 py-2 rounded-lg flex items-center gap-2 text-emerald-800 font-medium">
                <SafeIcon name="Check" />
                {t.uploadSuccess}
              </div>
            </div>
          </div>
        ) : (
          <div className="text-center flex flex-col items-center text-gray-500 group-hover:text-emerald-600 transition-colors">
            <SafeIcon name="Camera" className="text-3xl mb-2" />
            <span className="text-sm font-medium">{helpText}</span>
          </div>
        )}
      </div>
    </div>
  );
}